<template>
  <b-nav-item-dropdown right no-caret>
    <template slot="button-content">
      <span style="width: 100px" title="Language">
        <img
          :src="'static/icons/language.svg'"
          height="25"
        />
        <span v-if="showLangLabel" class="label">{{lang}}</span>
        <i style="color: #6F3996" class="bi bi-caret-down-fill"></i>
      </span>
    </template>
    <div v-for="(l, langIdx) in getAvailableLangs" :key="langIdx">
      <b-dropdown-item
        v-if="!['tr', 'bs'].includes(l)"
        :class="lang == l ? 'selected' : ''"
        @click="setLangNew(l)"
      >
        <template v-if="l === 'en'">
          {{ $t("headerMenu_language_english_caption") }}
        </template>
        <template v-else-if="l === 'es'">
          {{ $t("headerMenu_language_spanish_caption") }}
        </template>
        <template v-else-if="l === 'tr'">
          {{ $t("headerMenu_language_turkish_caption") }}
        </template>
        <template v-else-if="l === 'pt'">
          {{ $t("headerMenu_language_portuguese_caption") }}
        </template>
        <template v-else>
          {{ l }}
        </template>
      </b-dropdown-item>
    </div>
  </b-nav-item-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TemplateLanguageSelector",
  props: {
    showLangLabel:{
      type: Boolean,
      default: false
    }
  },
  created: function () {
    this.availableLangs();
  },
  methods: {
    setLangNew: function (lang) {
      this.$store.dispatch("setLangNew", lang);
    },
    availableLangs() {
      this.$store.dispatch("availableLanguages");
    },
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapGetters(["getAvailableLangs"]),
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/variables.scss';

.label{
  text-transform: uppercase;
  font-size: 1.1em;
  color: $primary-color;
  font-family: $font-subtitle-light;
  margin: 5px;
}

.lang-image {
  position: relative;
  top: -3px;
}
.selected {
  font-weight: bold;
}
i.icon.icon-language {
  height: 1.2em;
  width: 1.2em;
}

</style>
